import styled from 'styled-components';
import Icon from '../../../atoms/Icon';
import { IconMap } from '../../../atoms/Icon/helpers/iconMap';
import { FormattedMessage } from 'react-intl';

const MetaContainer = styled.div`
  display: flex;
  margin-bottom: 20px;
`;

const StyledIcon = styled(Icon)`
  color: ${(props) => props.theme.color.black500};
  margin: 5px 20px 20px 0;
`;

/**
 * @param {string} name
 * @returns {string}
 */
const formatChannelName = (name) =>
  name.charAt(0).toUpperCase() + name.slice(1).toLocaleLowerCase();

/**
 * @param {string} isoString
 * @returns {Date}
 */
const getDateFromIso = (isoString) => new Date(isoString);

/**
 * @param {MetaProps} props
 * @returns {React.ReactElement} The rendered component
 */
const SocialMeta = ({ createdAt, type }) => {
  const iconType = type in IconMap ? type : 'DEFAULTCHANNEL';
  return (
    <MetaContainer>
      <StyledIcon icon={iconType} />
      <div>
        <FormattedMessage
          id="socialStream.viaChannel"
          values={{
            channel: formatChannelName(type),
          }}
        />
        <FormattedMessage
          id="socialStream.postedDate"
          values={{
            isoString: getDateFromIso(createdAt),
          }}
        />
      </div>
    </MetaContainer>
  );
};

export default SocialMeta;
